import { CodeIcon } from "@heroicons/react/solid";
import React, { useMemo, useRef, useState } from "react";
import { projects } from "../../data";
import MainIntersectProvider from "../../MainIntersectProvider";
import Project from "./Project/Project";

const ITEMS_TO_LOAD_AT_EACH_TIME = 3;

export default function Projects() {
	const [data] = useState(projects);
	const [numberOfitemsShown, setNumberOfItemsToShown] = useState(
		ITEMS_TO_LOAD_AT_EACH_TIME
	);

	const showMore = () => {
		setNumberOfItemsToShown((items) => items + ITEMS_TO_LOAD_AT_EACH_TIME);
	};

	const dummyRef = useRef(null);
	const showLess = () => {
		setNumberOfItemsToShown(ITEMS_TO_LOAD_AT_EACH_TIME);
		dummyRef.current.scrollIntoView({ behavior: "smooth" });
	};

	const itemsToShow = useMemo(() => {
		return data.slice(0, numberOfitemsShown);
	}, [data, numberOfitemsShown]);

	return (
		<section id='projects' className='text-gray-400  body-font'>
			{/* to scroll when user clicks on SHOW LESS button */}
			<div ref={dummyRef} />
			<div className='container px-5 xl:px-40 py-20 mx-auto text-center'>
				<div className='flex flex-col w-full mb-20'>
					<MainIntersectProvider>
						<CodeIcon className='mx-auto inline-block w-10 mb-4' />
					</MainIntersectProvider>
					<h1 className='sm:text-3xl text-2xl font-medium title-font text-white mb-4'>
						Things I've built so far
					</h1>
					<p className='text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto'>
						A few projects that I've recently developed
					</p>
				</div>
				<div className='flex flex-wrap space-y-5'>
					{itemsToShow.map((project, index) => (
						<Project key={project.title.substring(0, 4)} project={project} />
					))}
				</div>
				<div className='pt-10'>
					{itemsToShow.length < data.length ? (
						<button
							onClick={showMore}
							className='px-10 py-2 border-2 border-gray-400'
						>
							Show More
						</button>
					) : (
						<button
							onClick={showLess}
							className='px-10 py-2 border-2 border-gray-400'
						>
							Show Less
						</button>
					)}
				</div>
			</div>
		</section>
	);
}
